import React from 'react'

import BuildingsList from '../../components/Buildings/BuildingsList.jsx'
import BuildingGroupsSort from '../../components/Buildings/BuildingGroupsSort.jsx'
import NavLink from '../../components/Routes/NavLink'

import {user} from '../../core/controllers/user';
import {buildings} from '../../core/controllers/Buildings'

export default class HomeTemplate extends React.Component { 
    constructor(props) {
        super(props);

        this.state = {
            sortID : "all"
        };
        this.lastSortID = "all"
    }

    componentDidMount() {
        buildings.getBuildings(this);
    }

    // #  Triggers buildings to be called, belonging to selected id
    sortBuildingSelect(e) {
        this.setState({
            sortID: e.target.value
        });
    }

    render(){
        const buildingData = this.state.data;
        return (
            <div>
                {buildingData != null && buildingData.length > 0 ? (
                <div>
                    <div class="row">
                        <div class="main-page-header-row col-md-12">
                            <div class="col-md-3">
                                <span class="main-page-header-title">Connected</span>
                            </div>
                            <div class="col-md-2 col-md-offset-7">
                                <NavLink to={"/building/new"}>
                                    <button type="button" id="add-building" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off">
                                        Add Building
                                    </button>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="card">
                            <div class="header">
                                <h4 class="title">Building(s) Dashboard</h4>
                                <p class="category"></p>
                            </div>
                            <div class="content">
                                <div class="row">
                                    <BuildingGroupsSort onChange={this.sortBuildingSelect.bind(this)}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <BuildingsList sortID={this.state.sortID}/>
                    </div>
                </div>
                ) : (
                    <div>
                        <div style={{textAlign: "center"}}>
                            <div class="row">
                                <div class="main-page-header-row col-md-12">
                                    <div class="row">
                                        <span class="main-page-header-title">No Buildings Yet</span>
                                    </div>
                                    <div class="row" style={{marginTop: "10px"}}>
                                        <NavLink to={"/building/new"}>
                                            <button type="button" id="add-building" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off">
                                                Add Building
                                            </button>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12" style={{backgroundImage: "url('/assets/img/connected.png')", backgroundRepeat: 'no-repeat', backgroundPosition: 'top', backgroundSize: 'contain', minHeight: '565px'}}></div>
                    </div>
                )}
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/views/Buildings/Buildings.jsx